module.exports = __webpack_public_path__ + "img/dg.459ffc4c.png";